import { apiClient } from "../config";

async function archiveOrRestoreSpecie(id: any, status: any) {
  const url = `/admin/species/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreSpecie;
